import { useDefaultLink } from '@shared/hooks';
import { ref } from 'vue';
import { MANAGER_CARD_TYPE } from '@shared/config';

/**
 * 名片类型
 */
export enum CARD_TYPE {
  /**
   * 名片版
   */
  CARD = 1,
  /**
   * 头图版(头图就是背景图)
   */
  WITH_BG = 2,
  /**
   * 广州银行定制版
   */
  CUSTOMIZE = 3,
  /*
   * 图片海报版名片
   */
  PIC_POSTER = 4,
}

export enum CardLayoutPattern {
  /**
   * 商务版
   */
  BusinessVersion,
  /**
   * 现代版
   */
  ModernVersion,
}

export const piTaskId = ref();
export const isArticle = ref();
export const objId = ref();
export const phoneTrack = ref<Record<string, any>>();

export const useCard = () => {
  const { toPath } = useDefaultLink();

  const clickEditBtn = (e: MouseEvent) => {
    _jt_.sendTracker({
      event_type: 'click',
      block_desc: 'cardEditor',
      button_desc: 'enter_btn',
    });
    e.preventDefault();
    e.stopPropagation();
    toPath('push', {
      path: 'app://caizhi_webapp/cardEditor',
      query: { type: MANAGER_CARD_TYPE.PageCard },
    });
  };

  return {
    clickEditBtn,
  };
};
